module.exports = __webpack_public_path__ + "static/media/caja1.7d6f80df.jpg";